/**
 * @generated SignedSource<<cda7bc03026033e95f7c74fc65280db0>>
 * @relayHash 3324147c9e3944a7f2559727e1f42139
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3603b8d4f9dcb53bf86aba4fdc5e6e4dde30ae8663b3707c7575a7a49b16c644

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FiltersMenuContentQuery$variables = {
  first?: number | null | undefined;
  projectId: string;
};
export type FiltersMenuContentQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly id: string;
      readonly key: string;
    };
    readonly jwmFilters: {
      readonly __typename: "JiraWorkManagementFilterConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly jql: string;
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"SavedFilterMenuItem_filter">;
        };
      } | null | undefined>;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type FiltersMenuContentQuery = {
  response: FiltersMenuContentQuery$data;
  variables: FiltersMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "contextId",
        "variableName": "projectId"
      }
    ],
    "kind": "ObjectValue",
    "name": "searchParameters"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "jql"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "jwmFilters",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v3/*: any*/),
                    "action": "THROW",
                    "path": "jira.jwmFilters.__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraWorkManagementFilterEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraWorkManagementFilter",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "FragmentSpread",
                                    "name": "SavedFilterMenuItem_filter"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v4/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.id"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v5/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.name"
                                  },
                                  {
                                    "kind": "RequiredField",
                                    "field": (v6/*: any*/),
                                    "action": "THROW",
                                    "path": "jira.jwmFilters.edges.node.jql"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.jwmFilters.edges.node"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.jwmFilters.edges"
                      }
                    ],
                    "type": "JiraWorkManagementFilterConnection"
                  },
                  (v7/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.jwmFilters"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v8/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v4/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProject.id"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v9/*: any*/),
                    "action": "THROW",
                    "path": "jira.jiraProject.key"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FiltersMenuContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "jwmFilters",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraWorkManagementFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraWorkManagementFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isEditable"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraWorkManagementFilterConnection"
              },
              (v7/*: any*/)
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3603b8d4f9dcb53bf86aba4fdc5e6e4dde30ae8663b3707c7575a7a49b16c644",
    "metadata": {},
    "name": "FiltersMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5fd2b2fec282b26dc599d6b19a7bb3fd";

export default node;
